import { __extends, __assign } from 'tslib';
import React__default from 'react';
import Cropper from 'react-cropper';
import debounce from 'lodash.debounce';
import { propTypes, defaultProps } from './ImageCropper.types.js';
import ZoomControl from './ZoomControl.component.js';
import './ImageCropper.scss.js';
import styles from './ImageCropper.module.scss.js';

var ImageCropper = /** @class */ (function (_super) {
    __extends(ImageCropper, _super);
    function ImageCropper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { zoom: 0 };
        _this.cropper = null;
        _this.crop = function () { var _a; return ((_a = _this.cropper) === null || _a === void 0 ? void 0 : _a.getCroppedCanvas().toDataURL()) || ''; };
        _this.handleManualZoom = function (event) {
            _this.setState({ zoom: event.detail.ratio });
        };
        _this.handleZoom = function (newZoom) {
            if (_this.cropper) {
                var _a = _this.cropper.getContainerData(), width = _a.width, height = _a.height;
                var pivot = { x: width / 2, y: height / 2 };
                _this.cropper.zoomTo(newZoom, pivot);
            }
            _this.setState({ zoom: newZoom });
        };
        return _this;
    }
    ImageCropper.prototype.onCropperInit = function (cropper) {
        this.cropper = cropper;
    };
    ImageCropper.prototype.render = function () {
        var _this = this;
        var _a = this.props, src = _a.src, className = _a.className, width = _a.width, height = _a.height, showZoomControl = _a.showZoomControl, onUrlDataChange = _a.onUrlDataChange, debounceInterval = _a.debounceInterval;
        var zoom = this.state.zoom;
        var debounceCropHandler = onUrlDataChange
            ? debounce(function () { return onUrlDataChange === null || onUrlDataChange === void 0 ? void 0 : onUrlDataChange(_this.crop()); }, debounceInterval)
            : undefined;
        return (React__default.createElement("div", { className: styles.ImageCropper + " " + (className || ''), style: { height: height, width: width } },
            React__default.createElement(Cropper, { src: src, style: { height: height, width: width }, onInitialized: this.onCropperInit.bind(this), dragMode: "move", cropBoxMovable: false, cropBoxResizable: false, minContainerWidth: width, minContainerHeight: height, minCropBoxWidth: width, minCropBoxHeight: height, guides: false, center: false, viewMode: 3, modal: false, highlight: false, zoom: this.handleManualZoom, zoomTo: zoom, className: styles.Omg, crop: debounceCropHandler }),
            showZoomControl && (React__default.createElement("div", { className: styles.ImageCropper_zoomContainer },
                React__default.createElement(ZoomControl, { minZoom: 0, maxZoom: 5, zoom: zoom, onChange: this.handleZoom })))));
    };
    ImageCropper.displayName = 'ImageCropper';
    ImageCropper.propTypes = propTypes;
    ImageCropper.defaultProps = __assign({}, defaultProps);
    return ImageCropper;
}(React__default.Component));

export { ImageCropper as default };
